<section class="auth-centered-page">
  <div class="auth-orb auth-orb--1"></div>
  <div class="auth-orb auth-orb--2"></div>

  <div class="auth-card">
    <div class="text-center mb-4">
      <a routerLink="/">
        <img src="assets/images/Logo ver 1.png" alt="Radwa Khallaf" class="auth-logo" />
      </a>
      <div class="auth-ornament">
        <span class="auth-orn-rule"></span>
        <span class="auth-orn-gem">✦</span>
        <span class="auth-orn-rule"></span>
      </div>
    </div>
    <span class="auth-step-label">Account Recovery</span>
    <h2 class="auth-form-title">Forgot Password?</h2>
    <p class="auth-form-sub">Enter your email address and we'll send you a reset link.</p>

    <div class="form-group-lux">
      <label for="emailReset">Email Address</label>
      <input
        id="emailReset"
        [(ngModel)]="emailText"
        type="email"
        class="form-control lux-input"
        placeholder="you@example.com"
        autocomplete="email"
      />
    </div>

    <button (click)="submit()" class="btn-auth">
      Send Reset Link
    </button>

    <p class="auth-switch mt-3">
      Remember your password? <a routerLink="/login">Sign in</a>
    </p>
  </div>
</section>
